/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.controllers {
    export interface IApiKeyScope extends angular.IScope{
       model: models.ApiKeyModel; 
    }
    export class ApiKeyController {
        constructor(private $scope: IApiKeyScope, private apiKeyService: warsApp.services.ApiKeyService) {
            this.$scope.model = new warsApp.models.ApiKeyModel(apiKeyService);
        }
    }
}

warsApp.registerController('ApiKeyController', ['$scope','apiKeyService']);